import { render } from "./CancelOrderModal.vue?vue&type=template&id=1bc00243&scoped=true"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js"

import "./CancelOrderModal.vue?vue&type=style&index=0&id=1bc00243&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc00243"]])

export default __exports__